<template>
    <el-container class="mainJjglxxBody">
        <el-col class="box">
            <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="headOne">{{JjjgxxList.JGMC}}</div>
                    <div class="headSecond">{{JjjgxxList.GSDZ}}</div>
                </div>
                <el-row>
                <span class="xxContent1">
                    姓名：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    从业人员编号：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    服务机构：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    评价方：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    评价日期：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    评价结果：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
            </el-card>
        </el-col>
    </el-container>
</template>

<script>
    export default {
        name: "jjjggs_cx",
        data() {
            return {
                JjjgxxList:{
                    JGMC:'汉中鸿润置业有限公司',
                    GSDZ:'汉中市汉台区汉中颐高互联网双创园',
                    BAZH:'某某',
                },
            }
        },
    }
</script>

<style scoped>
    @import "../../assets/css/jjgl/jjglxx_main.css";
</style>